import React, { useEffect, useState } from "react";
import ReactDOMServer from "react-dom/server";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import Content from "../common/template/content";
import ContentCard from "../common/template/contentCard";
import ContentCardHeader from "../common/template/contentCardHeader";
import ContentCardBody from "../common/template/contentCardBody";
import Row from "../common/layout/row";
import Grid from "../common/layout/grid";
import Table from "../common/table/table";
import THead from "../common/table/tHead";
import NewTr from "../common/table/newTr";
import Tr from "../common/table/tr";
import Th from "../common/table/th";
import TBody from "../common/table/tBody";
import Td from "../common/table/td";
import ButtonTable from "../common/table/buttonTable";
import Button from "../common/button/button";
import Form from "./faturaForm";
import Select from "../common/form/select";
import { Loading } from "../common/loading/loading";
import { DisplayPDF } from "../displayPDF/displayPDF";
import {
    setModoTela,
    initForm,
    setFiltro,
    salvar,
    salvarMultiplos,
    excluir,
    getListaFaturasEngenharia,
    buscarPdf,
    gerarRelatorio,
    getListaClientesUcsFiltradosSelect,
} from "./faturaActions";
import { reprocessar, reprocessarTodas, setAguardando } from "./faturaItem/faturaItemActions";
import { setArquivoPDF } from "../displayPDF/displayPDFActions";
import LabelAndCheckbox from "../common/form/labelAndCheckbox";
// import { htmlToPdf } from "../htmlToPdf/htmlToPdf";

import TabelaFaturaEngenhariaPDF from "../htmlToPdf/TabelaFaturaEngenhariaPDF";
import TableInCell from "../common/table/tableInCell";
import { adicionarPontosMilhar } from "../utils/adicionarPontosMilhar";
import { setError } from "../common/toast/toast";
import { ModalGestorConcessonaria } from "../analise/components/ModalGestorConcessionaria";
import { LabelSelectUcIconeGestor } from "../common/form/LabelSelectUcIconeGestor";

const INITIAL_STATE = {
    statusAmareloClaro: true,
    statusAmareloEscuro: true,
    statusLaranja: true,
    statusRoxo: true,
    statusBranco: true,
    exibirModalGestorConcessionaria: false,
    itemSelecionado: null,
};

const INITIAL_TOTAIS = {
    qtdStatusAmareloClaro: 0,
    qtdStatusAmareloEscuro: 0,
    qtdStatusLaranja: 0,
    qtdStatusRoxo: 0,
    qtdStatusBranco: 0,
    totalValorImportado: 0,
    totalValorFatura: 0,
    totalenergia: 0,
    totalEnergiaPonta: 0,
    totalEnergiaForaPonta: 0,
    totalEnergiaReservado: 0,
    totalDemanda: 0,
    totalDemandaPonta: 0,
    totalDemandaGeracao: 0,
    totalValorDemanda: 0,
    totalValorDemandaPonta: 0,
    totalValorDemandaGeracao: 0,
    totalEnergiaReativo: 0,
    totalGastoReativo: 0,
    totalGastoDemandaComplementar: 0,
    totalGastoDemandaComplementarPonta: 0,
    totalGastoDemandaUltrapassagem: 0,
    totalGastoDemandaUltrapassagemPonta: 0,
    totalGastoDemandaUltrapassagemGeracao: 0,
};

function FaturaEngenharia(props) {
    const [faturasFiltradas, setFaturasFiltradas] = useState([]);
    const [state, setState] = useState(INITIAL_STATE);
    const [totais, setTotais] = useState(INITIAL_TOTAIS);

    function handleResetStates() {
        setFaturasFiltradas([]);
        setTotais(INITIAL_TOTAIS);
    }

    useEffect(() => {
        props.getListaClientesUcsFiltradosSelect();
        props.getListaFaturasEngenharia();
    }, []);

    useEffect(() => {
        handleResetStates();
        props.getListaFaturasEngenharia();
    }, [props.filtro]);

    useEffect(() => {
        if (!props.usuarioLogado) return;
        const listaAtualizada = [];
        const totaisAtualizados = { ...INITIAL_TOTAIS };
        for (const item of props.lista) {
            if (!itemCorrespondeAoFiltro(item)) {
                // console.log("uc" + item.id_unidade_consumidora + " IGNORADA");
                continue;
            }
            listaAtualizada.push(item);
            contabilizarTotais({ item, totais: totaisAtualizados });
            // console.log(item.id_unidade_consumidora + " INCLUIDO");
        }

        setFaturasFiltradas(listaAtualizada);
        setTotais(totaisAtualizados);
    }, [props.lista, props.usuarioLogado, props.filtro, state.statusAmareloClaro, state.statusAmareloEscuro, state.statusLaranja, state.statusRoxo, state.statusBranco]);

    if (props.pdf) {
        return <DisplayPDF closePdf={props.setArquivoPDF} pdfBase64={props.pdf} nomePdf={props.nomePdf} orientation={props.orientation} zoomParametro={1.5} />;
    }
    return (
        <div>
            {props.aguardando ? <Loading /> : null}
            <Content>
                {props.modoTela == "engenharia" ? <Form engenharia /> : null}
                {props.modoTela == "lista" ? lista() : null}
            </Content>
        </div>
    );

    function getStyleSlimCard(bgColor, textColor) {
        return {
            borderRadius: 8,
            cursor: "pointer",
            backgroundColor: bgColor,
            color: textColor || null,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            padding: "10px 10px 0px 10px",
            width: "100%",
            minHeight: "40px",
            margin: 5,
            boxShadow: "#9b9b9b 0px 1px 2px 1px",
        };
    }

    function itemCorrespondeAoFiltro(item) {
        let itemStatusBranco = false;
        let itemStatusAmareloClaro = false;
        let itemStatusAmareloEscuro = false;
        let itemStatusLaranja = false;
        let itemStatusRoxo = false;
        let nivelErro = 0;
        if (item.erros_engenharia && item.erros_engenharia.length > 0) {
            nivelErro = item.erros_engenharia[0].nivel || 1;
        }
        switch (nivelErro) {
            case 1:
                itemStatusAmareloClaro = state.statusAmareloClaro;
                break;
            case 2:
                itemStatusAmareloEscuro = state.statusAmareloEscuro;
                break;
            case 3:
                itemStatusLaranja = state.statusLaranja;
                break;
            case 4:
                itemStatusRoxo = state.statusRoxo;
                break;
            default:
                itemStatusBranco = state.statusBranco;
                break;
        }
        return itemStatusBranco || itemStatusAmareloClaro || itemStatusAmareloEscuro || itemStatusLaranja || itemStatusRoxo;
    }

    function contabilizarTotais({ item, totais }) {
        totais.totalValorImportado += parseFloat(item.total > 0 ? item.total : 0);
        totais.totalValorFatura += parseFloat(item.valor_fatura > 0 ? item.valor_fatura : 0);
        totais.totalenergia += parseFloat(item.energia || 0);
        totais.totalEnergiaPonta += parseFloat(item.energia_ponta || 0);
        totais.totalEnergiaForaPonta += parseFloat(item.energia_fora_ponta || 0);
        totais.totalEnergiaReservado += parseFloat(item.energia_reservado || 0);
        totais.totalDemanda += parseFloat(item.demanda || 0);
        totais.totalDemandaPonta += parseFloat(item.demanda_ponta || 0);
        totais.totalDemandaGeracao += parseFloat(item.demanda_geracao || 0);
        totais.totalValorDemanda += parseFloat(item.valor_demanda || 0);
        totais.totalValorDemandaPonta += parseFloat(item.valor_demanda_ponta || 0);
        totais.totalValorDemandaGeracao += parseFloat(item.valor_demanda_geracao || 0);
        totais.totalEnergiaReativo += parseFloat(item.energia_reativo || 0);
        totais.totalGastoReativo += parseFloat(item.gasto_reativo || 0);
        totais.totalGastoDemandaComplementar += parseFloat(item.gasto_demanda_complementar || 0);
        totais.totalGastoDemandaComplementarPonta += parseFloat(item.gasto_demanda_complementar_ponta || 0);
        totais.totalGastoDemandaUltrapassagem += parseFloat(item.gasto_demanda_ultrapassagem || 0);
        totais.totalGastoDemandaUltrapassagemPonta += parseFloat(item.gasto_demanda_ultrapassagem_ponta || 0);
        totais.totalGastoDemandaUltrapassagemGeracao += parseFloat(item.gasto_demanda_ultrapassagem_geracao || 0);

        switch (item.cor) {
            case "AMARELO_CLARO":
                totais.qtdStatusAmareloClaro++;
                break;
            case "AMARELO_ESCURO":
                totais.qtdStatusAmareloEscuro++;
                break;
            case "LARANJA":
                totais.qtdStatusLaranja++;
                break;
            case "ROXO":
                totais.qtdStatusRoxo++;
                break;
            default:
                totais.qtdStatusBranco++;
                break;
        }
    }

    function lista() {
        let statusAtivos = [];
        if (state.statusAmareloClaro) statusAtivos.push("Fatura com multa leve");
        if (state.statusAmareloEscuro) statusAtivos.push("Fatura com multa moderada");
        if (state.statusLaranja) statusAtivos.push("Faturas com multa elevada");
        if (state.statusRoxo) statusAtivos.push("Fatura com multa severa");
        if (state.statusBranco) statusAtivos.push("Sem multa regulatória");
        if (state.statusAmareloClaro && state.statusAmareloEscuro && state.statusLaranja && state.statusRoxo && state.statusBranco) statusAtivos = "Todas as faturas";

        //DADOS PARA IMPRESSÃO DO RELATÓRIO ---------------
        const cabecalho = (
            <NewTr backgroundColorTr={"#FFFFFF"} backgroundColorTd={"#F9F9F9"}>
                <Th style={{ fontSize: "0.8rem" }} sticky minWidth={50}>
                    Status
                </Th>
                <Th style={{ fontSize: "0.8rem" }} sticky minWidth={90}>
                    Competência
                </Th>
                <Th style={{ fontSize: "0.8rem" }} sticky minWidth={50}>
                    Cliente
                </Th>
                <Th style={{ fontSize: "0.8rem" }} sticky minWidth={50}>
                    UC
                </Th>
                <Th style={{ fontSize: "0.7rem" }} sticky minWidth={50} alignCenter>
                    Total Fatura
                </Th>
                <Th style={{ fontSize: "0.7rem" }} sticky minWidth={50} alignCenter>
                    Energia (kWh)
                </Th>

                <Th style={{ fontSize: "0.7rem" }} sticky minWidth={50} alignCenter>
                    Demanda
                </Th>

                <Th style={{ fontSize: "0.7rem" }} sticky minWidth={70} alignCenter>
                    ICMS (%)
                </Th>

                <Th style={{ fontSize: "0.7rem" }} sticky minWidth={70} alignCenter backgroundColor="#E0E0E0">
                    Multa Reativo (R$)
                </Th>
                <Th style={{ fontSize: "0.7rem" }} sticky minWidth={105} alignCenter backgroundColor="#E0E0E0">
                    Multa Demanda Complementar (R$)
                </Th>
                <Th style={{ fontSize: "0.7rem" }} sticky minWidth={110} alignCenter backgroundColor="#E0E0E0">
                    Multa Demanda Ultrapassagem (R$)
                </Th>
                <Th style={{ fontSize: "0.7rem" }} sticky minWidth={110} alignCenter backgroundColor="#E0E0E0">
                    Multa Total (R$)
                </Th>
                <Th style={{ fontSize: "0.7rem" }} sticky minWidth={50} alignCenter>
                    PDF
                </Th>
            </NewTr>
        );

        const rodape = (
            <Tr>
                <Td style={{ fontSize: "0.8rem" }} colSpan={4} fontWeight="bold">
                    Total
                </Td>
                <Td style={{ fontSize: "0.8rem" }} fontWeight="bold">
                    {adicionarPontosMilhar(totais.totalValorFatura || 0)}
                </Td>
                <Td style={{ fontSize: "0.8rem" }} fontWeight="bold">
                    <TableInCell
                        lista={[
                            { cabecalho: "Total (kWh)", valor: adicionarPontosMilhar(totais.totalenergia || 0) },
                            { cabecalho: "Ponta (kWh)", valor: adicionarPontosMilhar(totais.totalEnergiaPonta || 0) },
                            { cabecalho: "Fora Ponta (kWh)", valor: adicionarPontosMilhar(totais.totalEnergiaForaPonta || 0) },
                            { cabecalho: "Reservado (kWh)", valor: adicionarPontosMilhar(totais.totalEnergiaReservado || 0) },
                        ]}
                    />
                </Td>

                <Td style={{ fontSize: "0.8rem" }} fontWeight="bold">
                    <TableInCell
                        lista={[
                            {
                                cabecalho: "Ponta",
                                valores: [adicionarPontosMilhar(totais.totalDemandaPonta || 0) + " kW", "R$ " + adicionarPontosMilhar(totais.totalValorDemandaPonta || 0)],
                            },
                            {
                                cabecalho: "Fora Ponta",
                                valores: [adicionarPontosMilhar(totais.totalDemanda || 0) + " kW", "R$ " + adicionarPontosMilhar(totais.totalValorDemanda || 0)],
                            },
                            {
                                cabecalho: "Demanda G",
                                valores: [adicionarPontosMilhar(totais.totalDemandaGeracao || 0) + " kW", "R$ " + adicionarPontosMilhar(totais.totalValorDemandaGeracao || 0)],
                            },
                        ]}
                    />
                </Td>

                <Td style={{ fontSize: "0.8rem" }} fontWeight="bold">
                    {/*rodapé do icms*/}
                </Td>
                <Td style={{ fontSize: "0.8rem" }} alignCenter fontWeight="bold">
                    {adicionarPontosMilhar(totais.totalGastoReativo || 0)}
                </Td>
                <Td style={{ fontSize: "0.8rem" }} fontWeight="bold" alignCenter>
                    <TableInCell
                        lista={[
                            { cabecalho: "Ponta (R$)", valor: adicionarPontosMilhar(totais.totalGastoDemandaComplementarPonta || 0) },
                            { cabecalho: "Fora Ponta (R$)", valor: adicionarPontosMilhar(totais.totalGastoDemandaComplementar || 0) },
                            { cabecalho: "Total (R$)", valor: adicionarPontosMilhar(totais.totalGastoDemandaComplementarPonta + totais.totalGastoDemandaComplementar) },
                        ]}
                    />
                </Td>
                <Td style={{ fontSize: "0.8rem" }} fontWeight="bold" alignCenter>
                    <TableInCell
                        lista={[
                            { cabecalho: "Ponta (R$)", valor: adicionarPontosMilhar(totais.totalGastoDemandaUltrapassagemPonta || 0) },
                            { cabecalho: "Fora Ponta (R$)", valor: adicionarPontosMilhar(totais.totalGastoDemandaUltrapassagem || 0) },
                            { cabecalho: "Geração (R$)", valor: adicionarPontosMilhar(totais.totalGastoDemandaUltrapassagemGeracao || 0) },
                            {
                                cabecalho: "Total (R$)",
                                valor: adicionarPontosMilhar(
                                    totais.totalGastoDemandaUltrapassagem + totais.totalGastoDemandaUltrapassagemPonta + totais.totalGastoDemandaUltrapassagemGeracao
                                ),
                            },
                        ]}
                    />
                </Td>
                <Td style={{ fontSize: "0.8rem" }} alignCenter fontWeight="bold">
                    {adicionarPontosMilhar(
                        totais.totalGastoReativo +
                            totais.totalGastoDemandaComplementarPonta +
                            totais.totalGastoDemandaComplementar +
                            totais.totalGastoDemandaUltrapassagem +
                            totais.totalGastoDemandaUltrapassagemPonta +
                            totais.totalGastoDemandaUltrapassagemGeracao
                    )}
                </Td>
                <Td></Td>
                <Td></Td>
            </Tr>
        );

        const podeLimparFiltro = props.filtro.ano || props.filtro.mes || props.filtro.id_cliente || props.filtro.id_unidade_consumidora;

        //-------------------------------------------------
        return (
            <>
                <ContentCard>
                    <ModalGestorConcessonaria
                        visible={state.exibirModalGestorConcessionaria && state.itemSelecionado && state.itemSelecionado.gestor_concessionaria_energia}
                        itemSelecionado={state.itemSelecionado}
                        handleClose={() => setState({ ...state, exibirModalGestorConcessionaria: false, itemSelecionado: null })}
                    />
                    <ContentCardBody>
                        <Row>
                            {props.usuarioLogado && !props.usuarioLogado.acesso_cliente ? (
                                <Select
                                    name="id_cliente"
                                    options={props.listaCliente}
                                    label="Cliente"
                                    cols="12 6 4"
                                    placeholder="Selecione o Cliente"
                                    value={props.filtro.id_cliente}
                                    onChange={(value) => {
                                        if (!podeLimparFiltro) {
                                            setError("Escolha uma UC, um ano ou um mês para melhorar a listagem dos resultados.");
                                            return;
                                        }
                                        props.setFiltro({
                                            ...props.filtro,
                                            id_cliente: value,
                                        });
                                    }}
                                />
                            ) : null}

                            <Select
                                name="id_unidade_consumidora"
                                options={props.listaUnidadeConsumidora.filter((item) => !props.filtro.id_cliente || item.id_cliente == props.filtro.id_cliente)}
                                label={
                                    <LabelSelectUcIconeGestor
                                        filtro={props.filtro}
                                        listaUnidadeConsumidora={props.listaUnidadeConsumidora}
                                        setExibirModal={(ucFiltro) =>
                                            setState({
                                                ...state,
                                                exibirModalGestorConcessionaria: true,
                                                itemSelecionado: ucFiltro,
                                            })
                                        }
                                    />
                                }
                                cols="12 6 4"
                                placeholder="Selecione a UC"
                                value={props.filtro.id_unidade_consumidora}
                                onChange={(value) => {
                                    if (!podeLimparFiltro) {
                                        setError("Escolha uma cliente, um ano ou um mês para melhorar a listagem dos resultados.");
                                        return;
                                    }
                                    props.setFiltro({
                                        ...props.filtro,
                                        id_unidade_consumidora: value,
                                    });
                                }}
                            />

                            <Select
                                name="ano"
                                options={Array.from({ length: 20 }, (v, i) => ({
                                    id: new Date().getFullYear() - 5 + i,
                                    valor: new Date().getFullYear() - 5 + i,
                                }))}
                                label="Ano"
                                cols="12 6 2"
                                placeholder="Selecione o ano"
                                value={props.filtro.ano}
                                onChange={(value) => {
                                    if (!podeLimparFiltro) {
                                        setError("Escolha um cliente, uma UC ou um mês para melhorar a listagem dos resultados.");
                                        return;
                                    }
                                    props.setFiltro({
                                        ...props.filtro,
                                        ano: value,
                                    });
                                }}
                            />

                            <Select
                                name="mes"
                                options={props.listaMeses}
                                label="Mês"
                                cols="12 6 2"
                                placeholder="Selecione o mês"
                                value={props.filtro.mes}
                                onChange={(value) => {
                                    if (!podeLimparFiltro) {
                                        setError("Escolha um cliente, uma UC ou um ano para melhorar a listagem dos resultados.");
                                        return;
                                    }
                                    props.setFiltro({
                                        ...props.filtro,
                                        mes: value,
                                    });
                                }}
                            />
                        </Row>
                        <details open={window.innerWidth >= 950} style={{ marginBottom: 20 }}>
                            <summary>
                                <b>
                                    Filtro por Status
                                    {window.innerWidth >= 950 || !statusAtivos ? "" : ` (${statusAtivos})`.replace(/\,/g, ", ")}
                                </b>
                            </summary>
                            <div
                                style={{
                                    width: "100%",
                                    display: "flex",
                                    flexWrap: "wrap",
                                    marginBottom: 20,
                                    minHeight: "fit-content",
                                }}
                            >
                                <Grid
                                    cols="12 12 6 6"
                                    style={{
                                        display: "flex",
                                        justifyContent: "center",
                                        cursor: "pointer",
                                    }}
                                >
                                    <label style={getStyleSlimCard("#6dc9ff")} htmlFor="filtro-todas">
                                        <LabelAndCheckbox
                                            style={{ justifyContent: "center" }}
                                            readOnly={props.aguardando}
                                            modoCard={true}
                                            colorIcon="#000"
                                            id="filtro-todas"
                                            label={`Todas as faturas (${
                                                totais.qtdStatusAmareloClaro +
                                                totais.qtdStatusAmareloEscuro +
                                                totais.qtdStatusLaranja +
                                                totais.qtdStatusRoxo +
                                                totais.qtdStatusBranco
                                            })`}
                                            onChange={(e) =>
                                                setState({
                                                    ...state,
                                                    statusAmareloClaro: e.target.checked,
                                                    statusAmareloEscuro: e.target.checked,
                                                    statusLaranja: e.target.checked,
                                                    statusRoxo: e.target.checked,
                                                    statusBranco: e.target.checked,
                                                })
                                            }
                                            value={state.statusAmareloClaro && state.statusAmareloEscuro && state.statusLaranja && state.statusRoxo && state.statusBranco}
                                        />
                                    </label>
                                </Grid>
                                <Grid
                                    cols="12 12 6 6"
                                    style={{
                                        display: "flex",
                                        justifyContent: "center",
                                    }}
                                >
                                    <label style={getStyleSlimCard("#ffffff", "#333333")} htmlFor="filtro-branco">
                                        <LabelAndCheckbox
                                            style={{ justifyContent: "center" }}
                                            readOnly={props.aguardando}
                                            modoCard={true}
                                            colorIcon="#000"
                                            id="filtro-branco"
                                            label={`Sem multa regulatória (${totais.qtdStatusBranco})`}
                                            onChange={(e) =>
                                                setState({
                                                    ...state,
                                                    statusBranco: e.target.checked,
                                                })
                                            }
                                            value={state.statusBranco}
                                        />
                                    </label>
                                </Grid>

                                <Grid
                                    cols="12 12 6 3"
                                    style={{
                                        display: "flex",
                                        justifyContent: "center",
                                    }}
                                >
                                    <label style={getStyleSlimCard("#fff176", "#000")} htmlFor="filtro-amarelo-claro">
                                        <LabelAndCheckbox
                                            style={{ justifyContent: "center" }}
                                            readOnly={props.aguardando}
                                            modoCard={true}
                                            colorIcon="#000"
                                            id="filtro-amarelo-claro"
                                            label={`Fatura com multa leve (${totais.qtdStatusAmareloClaro})`}
                                            onChange={(e) =>
                                                setState({
                                                    ...state,
                                                    statusAmareloClaro: e.target.checked,
                                                })
                                            }
                                            value={state.statusAmareloClaro}
                                        />
                                    </label>
                                </Grid>
                                {window.innerWidth >= 992 ? (
                                    <Grid
                                        cols="12 12 6 3"
                                        style={{
                                            display: "flex",
                                            justifyContent: "center",
                                        }}
                                    >
                                        <label style={getStyleSlimCard("#ffb74d", "#000000")} htmlFor="filtro-amarelo-escuro">
                                            <LabelAndCheckbox
                                                style={{ justifyContent: "center" }}
                                                readOnly={props.aguardando}
                                                modoCard={true}
                                                colorIcon="#000"
                                                id="filtro-amarelo-escuro"
                                                label={`Fatura com multa moderada (${totais.qtdStatusAmareloEscuro})`}
                                                onChange={(e) =>
                                                    setState({
                                                        ...state,
                                                        statusAmareloEscuro: e.target.checked,
                                                    })
                                                }
                                                divMargin={5}
                                                value={state.statusAmareloEscuro}
                                            />
                                        </label>
                                    </Grid>
                                ) : null}
                                <Grid
                                    cols="12 12 6 3"
                                    style={{
                                        display: "flex",
                                        justifyContent: "center",
                                    }}
                                >
                                    <label style={getStyleSlimCard("#ff7043", "#000000")} htmlFor="filtro-laranja">
                                        <LabelAndCheckbox
                                            style={{ justifyContent: "center" }}
                                            readOnly={props.aguardando}
                                            modoCard={true}
                                            colorIcon="#000"
                                            id="filtro-laranja"
                                            label={`Fatura com multa elevada (${totais.qtdStatusLaranja})`}
                                            onChange={(e) =>
                                                setState({
                                                    ...state,
                                                    statusLaranja: e.target.checked,
                                                })
                                            }
                                            value={state.statusLaranja}
                                        />
                                    </label>
                                </Grid>
                                <Grid
                                    cols="12 12 6 3"
                                    style={{
                                        display: "flex",
                                        justifyContent: "center",
                                        cursor: "pointer",
                                    }}
                                >
                                    <label style={getStyleSlimCard("#8f32a2", "#ffffff")} htmlFor="filtro-roxo">
                                        <LabelAndCheckbox
                                            style={{ justifyContent: "center" }}
                                            readOnly={props.aguardando}
                                            modoCard={true}
                                            colorIcon="#000"
                                            id="filtro-roxo"
                                            label={`Fatura com multa severa (${totais.qtdStatusRoxo})`}
                                            onChange={(e) =>
                                                setState({
                                                    ...state,
                                                    statusRoxo: e.target.checked,
                                                })
                                            }
                                            value={state.statusRoxo}
                                        />
                                    </label>
                                </Grid>
                            </div>
                        </details>
                    </ContentCardBody>
                </ContentCard>

                <ContentCard>
                    <ContentCardHeader>
                        <Grid cols="12 3 3 3">
                            <Button
                                text="Imprimir Relatório"
                                type={"primary"}
                                event={() => {
                                    if (faturasFiltradas.length > 100) {
                                        return setError("Existe mais de 100 registro, aplique algum filtro para reduzir a quantidade de registros do relatório");
                                    }
                                    const linhas = montarLinhas(faturasFiltradas);
                                    const totalCelulas = cabecalho.props.children.length;
                                    const linhaModificada = Array.from(cabecalho.props.children).splice(0, totalCelulas - 1);
                                    const cabecalhoSemColunasBotoes = (
                                        <NewTr>
                                            {linhaModificada.map((el, i) => {
                                                const copia = React.cloneElement(
                                                    el,
                                                    {
                                                        key: i,
                                                        sticky: false,
                                                        style: { fontSize: "0.85rem", paddingTop: 30 },
                                                    },
                                                    [...el.props.children]
                                                );
                                                return copia;
                                            })}
                                        </NewTr>
                                    );
                                    gerarRelatorio({
                                        statusAtivos,
                                        cabecalhoSemColunasBotoes,
                                        rodape,
                                        linhas,
                                    });
                                }}
                            />
                        </Grid>
                    </ContentCardHeader>
                    <ContentCardBody>
                        <Table responsive>
                            <THead>{cabecalho}</THead>
                            {props.aguardando ? null : (
                                <TBody>
                                    {faturasFiltradas.map((item) => buildRow(item))}
                                    {rodape}
                                </TBody>
                            )}
                        </Table>
                    </ContentCardBody>
                </ContentCard>
            </>
        );
    }

    function definirCorMensagem(item) {
        let mensagemTooltip = "";
        let corFundo = null;
        let corFundoEscuro = "#f8f2f2";
        let corFonte = "#000";

        switch (item.cor) {
            case "AMARELO_CLARO":
                corFundo = "#fff176";
                corFundoEscuro = "#b0a757";
                corFonte = "#000";
                mensagemTooltip = "multa leve, a ação de reduzir esse valor não representará logística";
                break;
            case "AMARELO_ESCURO":
                corFundo = "#ffb74d";
                corFundoEscuro = "#c19048";
                corFonte = "#000";
                mensagemTooltip = "multa moderada, deve ter atenção na frequência e verificar montantes anuais no módulo de análise";
                break;
            case "LARANJA":
                corFundo = "#ff7043";
                corFundoEscuro = "#b85a3d";
                corFonte = "#fff";
                mensagemTooltip = "multa elevada, deve ter atenção na frequência e verificar montantes anuais no módulo de análise";
                break;
            case "ROXO":
                corFundo = "#8f32a2";
                corFundoEscuro = "#641475";
                corFonte = "#fff";
                mensagemTooltip = "multa severa, deve buscar auxílio da engenharia para minimizar esse efeito";
                break;
            default:
                break;
        }
        return { mensagemTooltip, corFundo, corFundoEscuro, corFonte };
    }

    function definirMensagemErrosEngenharia(item) {
        const listaErros = (
            <div>
                <span>Verifique:</span>
                <ul style={{ paddingLeft: 20 }}>
                    {(item.erros_engenharia || []).map((erro, i) => (
                        <li key={i}>{erro.tipo}</li>
                    ))}
                </ul>
            </div>
        );

        const msgErroEngenharia = item.status === "Com Erros" ? listaErros : item.status;

        return msgErroEngenharia;
    }

    function buildRow(item) {
        const { mensagemTooltip, corFundo, corFundoEscuro, corFonte } = definirCorMensagem(item);
        const destacarConsumoReativo = (item.erros_engenharia || []).find((erro) => erro.tipo === "Consumo Reativo");
        const destacarDemandaComplementarForaPonta = (item.erros_engenharia || []).find(
            (erro) => erro.tipo === "Demanda Complementar" || erro.tipo === "Demanda Complementar Fora Ponta"
        );
        const destacarDemandaComplementarPonta = (item.erros_engenharia || []).find((erro) => erro.tipo === "Demanda Complementar Ponta");

        const destacarDemandaUltrapassagemForaPonta = (item.erros_engenharia || []).find(
            (erro) => erro.tipo === "Demanda Ultrapassagem" || erro.tipo === "Demanda Ultrapassagem Fora Ponta"
        );
        const destacarDemandaUltrapassagemPonta = (item.erros_engenharia || []).find((erro) => erro.tipo === "Demanda Ultrapassagem Ponta");
        const destacarDemandaUltrapassagemGeracao = (item.erros_engenharia || []).find((erro) => erro.tipo === "Demanda Ultrapassagem Geração");

        const msgErroEngenharia = definirMensagemErrosEngenharia(item);

        return (
            <NewTr
                title={mensagemTooltip}
                backgroundColorTr={corFundo}
                key={item.id + "-engenharia"}
                style={{
                    height: 40,
                    color: corFonte,
                }}
                botoes={[
                    {
                        type: "primary",
                        icon: "fas fa-eye",
                        event: () => {
                            props.setModoTela("engenharia", { ...item, competencia: `${item.competencia_formatada}` });
                            props.initForm({ ...item, competencia: `${item.competencia_formatada}` });
                        },
                    },
                ]}
            >
                <Td style={{ fontSize: "0.8rem" }}>{msgErroEngenharia}</Td>
                <Td style={{ fontSize: "0.8rem" }}>{`${item.competencia_formatada}`}</Td>
                <Td style={{ fontSize: "0.8rem" }} minWidth={100}>
                    {item.nome_cliente}
                </Td>
                <Td style={{ fontSize: "0.8rem" }} minWidth={150}>
                    {item.nome_unidade_consumidora}
                </Td>
                <Td style={{ fontSize: "0.8rem" }} alignCenter>
                    {adicionarPontosMilhar(item.valor_fatura || 0)}
                </Td>
                <Td style={{ fontSize: "0.8rem" }} alignCenter>
                    <TableInCell
                        lista={[
                            { cabecalho: "Total (kWh)", valor: adicionarPontosMilhar(item.energia || 0) },
                            { cabecalho: "Ponta (kWh)", valor: adicionarPontosMilhar(item.energia_ponta || 0) },
                            { cabecalho: "Fora Ponta (kWh)", valor: adicionarPontosMilhar(item.energia_fora_ponta || 0) },
                            { cabecalho: "Reservado (kWh)", valor: adicionarPontosMilhar(item.energia_reservado || 0) },
                        ]}
                    />
                </Td>

                <Td style={{ fontSize: "0.8rem" }} alignCenter>
                    <TableInCell
                        lista={[
                            {
                                cabecalho: "Ponta",
                                valores: [adicionarPontosMilhar(item.demanda_ponta || 0) + " kW", "R$ " + adicionarPontosMilhar(item.valor_demanda_ponta || 0)],
                            },
                            {
                                cabecalho: "Fora Ponta",
                                valores: [adicionarPontosMilhar(item.demanda || 0) + " kW", "R$ " + adicionarPontosMilhar(item.valor_demanda || 0)],
                            },
                            {
                                cabecalho: "Demanda G",
                                valores: [adicionarPontosMilhar(item.demanda_geracao || 0) + " kW", "R$ " + adicionarPontosMilhar(item.valor_demanda_geracao || 0)],
                            },
                        ]}
                    />
                </Td>
                <Td style={{ fontSize: "0.8rem" }} alignCenter>
                    <TableInCell
                        lista={[
                            {
                                cabecalho: "Esperado (%)",
                                valor: isNaN(parseFloat(item.icms_esperado)) ? " - " : adicionarPontosMilhar(item.icms_esperado),
                            },
                            {
                                cabecalho: "Importado (%)",
                                valor: isNaN(parseFloat(item.icms_importado)) ? " - " : adicionarPontosMilhar(item.icms_importado),
                            },
                        ]}
                    />
                </Td>
                <Td style={{ fontSize: "0.8rem" }} alignCenter backgroundColor={corFundoEscuro}>
                    <div
                        style={{
                            display: "flex",
                            height: "80%",
                            width: "100%",
                            padding: 2,
                            justifyContent: "center",
                            alignItems: "center",
                            textWeight: "bold",
                            backgroundColor: destacarConsumoReativo ? "#db0000" : null,
                            color: destacarConsumoReativo ? "#ffffff" : null,
                        }}
                    >
                        {adicionarPontosMilhar(item.gasto_reativo || 0)}
                    </div>
                </Td>

                <Td style={{ fontSize: "0.8rem" }} alignCenter backgroundColor={corFundoEscuro}>
                    <TableInCell
                        lista={[
                            {
                                cabecalho: "Ponta (R$)",
                                valor: (
                                    <div
                                        style={{
                                            display: "flex",
                                            height: "80%",
                                            width: "100%",
                                            padding: 2,
                                            justifyContent: "center",
                                            alignItems: "center",
                                            textWeight: "bold",
                                            backgroundColor: destacarDemandaComplementarPonta ? "#db0000" : null,
                                            color: destacarDemandaComplementarPonta ? "#ffffff" : null,
                                        }}
                                    >
                                        {adicionarPontosMilhar(item.gasto_demanda_complementar_ponta || 0)}
                                    </div>
                                ),
                            },
                            {
                                cabecalho: "Fora Ponta (R$)",
                                valor: (
                                    <div
                                        style={{
                                            display: "flex",
                                            height: "80%",
                                            width: "100%",
                                            padding: 2,
                                            justifyContent: "center",
                                            alignItems: "center",
                                            textWeight: "bold",
                                            backgroundColor: destacarDemandaComplementarForaPonta ? "#db0000" : null,
                                            color: destacarDemandaComplementarForaPonta ? "#ffffff" : null,
                                        }}
                                    >
                                        {adicionarPontosMilhar(item.gasto_demanda_complementar)}
                                    </div>
                                ),
                            },
                            {
                                cabecalho: "Total (R$)",
                                valor: adicionarPontosMilhar(parseFloat(item.gasto_demanda_complementar || 0) + parseFloat(item.gasto_demanda_complementar_ponta || 0)),
                            },
                        ]}
                    />
                </Td>
                <Td style={{ fontSize: "0.8rem" }} alignCenter backgroundColor={corFundoEscuro}>
                    <TableInCell
                        lista={[
                            {
                                cabecalho: "Ponta (R$)",
                                valor: (
                                    <div
                                        style={{
                                            display: "flex",
                                            height: "80%",
                                            width: "100%",
                                            padding: 2,
                                            justifyContent: "center",
                                            alignItems: "center",
                                            textWeight: "bold",
                                            backgroundColor: destacarDemandaUltrapassagemPonta ? "#db0000" : null,
                                            color: destacarDemandaUltrapassagemPonta ? "#ffffff" : null,
                                        }}
                                    >
                                        {adicionarPontosMilhar(item.gasto_demanda_ultrapassagem_ponta || 0)}
                                    </div>
                                ),
                            },
                            {
                                cabecalho: "Fora Ponta (R$)",
                                valor: (
                                    <div
                                        style={{
                                            display: "flex",
                                            height: "80%",
                                            width: "100%",
                                            padding: 2,
                                            justifyContent: "center",
                                            alignItems: "center",
                                            textWeight: "bold",
                                            backgroundColor: destacarDemandaUltrapassagemForaPonta ? "#db0000" : null,
                                            color: destacarDemandaUltrapassagemForaPonta ? "#ffffff" : null,
                                        }}
                                    >
                                        {adicionarPontosMilhar(item.gasto_demanda_ultrapassagem)}
                                    </div>
                                ),
                            },
                            {
                                cabecalho: "Geração (R$)",
                                valor: (
                                    <div
                                        style={{
                                            display: "flex",
                                            height: "80%",
                                            width: "100%",
                                            padding: 2,
                                            justifyContent: "center",
                                            alignItems: "center",
                                            textWeight: "bold",
                                            backgroundColor: destacarDemandaUltrapassagemGeracao ? "#db0000" : null,
                                            color: destacarDemandaUltrapassagemGeracao ? "#ffffff" : null,
                                        }}
                                    >
                                        {adicionarPontosMilhar(item.gasto_demanda_ultrapassagem_geracao || 0)}
                                    </div>
                                ),
                            },
                            {
                                cabecalho: "Total (R$)",
                                valor: adicionarPontosMilhar(
                                    parseFloat(item.gasto_demanda_ultrapassagem || 0) +
                                        parseFloat(item.gasto_demanda_ultrapassagem_ponta || 0) +
                                        parseFloat(item.gasto_demanda_ultrapassagem_geracao || 0)
                                ),
                            },
                        ]}
                    />
                </Td>
                <Td style={{ fontSize: "0.8rem" }} alignCenter backgroundColor={corFundoEscuro}>
                    {adicionarPontosMilhar(
                        parseFloat(item.gasto_reativo || 0) +
                            parseFloat(item.gasto_demanda_complementar || 0) +
                            parseFloat(item.gasto_demanda_complementar_ponta || 0) +
                            parseFloat(item.gasto_demanda_ultrapassagem || 0) +
                            parseFloat(item.gasto_demanda_ultrapassagem_ponta || 0) +
                            parseFloat(item.gasto_demanda_ultrapassagem_geracao || 0)
                    )}
                </Td>

                <Td style={{ fontSize: "0.8rem" }} alignCenter minWidth={50}>
                    {item.arquivo_pdf ? (
                        <ButtonTable
                            type={"primary"}
                            icon={"fas fa-file-pdf"}
                            visible={true}
                            event={() => {
                                props.buscarPdf(
                                    item.id,
                                    `Fatura_UC-${item.nome_unidade_consumidora.split("-")[0].trim()}_${String(item.competencia).substring(
                                        4,
                                        6
                                    )}-${String(item.competencia).substring(0, 4)}`
                                );
                                props.setArquivoPDF();
                            }}
                        />
                    ) : null}
                </Td>
            </NewTr>
        );
    }

    function montarLinhas(faturas) {
        const linhas = [];

        for (const item of faturas) {
            const linha = buildRow(item);
            const msgErroEngenharia = definirMensagemErrosEngenharia(item);
            const totalCelulas = linha.props.children.length;
            let linhaModificada = Array.from(linha.props.children).splice(0, totalCelulas - 1);
            linhaModificada = React.Children.map(linhaModificada, (child, index) => {
                // Extrai propriedades personalizadas da linha original
                const backgroundColorTd = linha.props.backgroundColorTd || "";
                const backgroundColorTr = linha.props.backgroundColorTr || "";

                // 0 = Msg Erro Importação
                if (index == 0) {
                    return React.cloneElement(child, {
                        backgroundColor: index % 2 === 0 ? backgroundColorTd : backgroundColorTr,
                        children: <div>{msgErroEngenharia.length > 32 ? msgErroEngenharia.substring(0, 32) + "..." : msgErroEngenharia}</div>,
                    });
                }

                // 2 = cliente
                if (index == 2) {
                    return React.cloneElement(child, {
                        backgroundColor: index % 2 === 0 ? backgroundColorTd : backgroundColorTr,
                        children: <div>{item.nome_cliente.length > 30 ? item.nome_cliente.substring(0, 30) + "..." : item.nome_cliente}</div>,
                    });
                }

                // 3 = UC
                if (index == 3) {
                    const nome_unidade_consumidora = item.nome_unidade_consumidora;
                    return React.cloneElement(child, {
                        backgroundColor: index % 2 === 0 ? backgroundColorTd : backgroundColorTr,
                        children: <div>{nome_unidade_consumidora.length > 40 ? `${nome_unidade_consumidora.substring(0, 40)}...` : nome_unidade_consumidora}</div>,
                    });
                }
                // Retorna o elemento sem alterações, mas aplica os estilos personalizados
                return React.cloneElement(child, {
                    backgroundColor: index % 2 === 0 ? backgroundColorTd : backgroundColorTr,
                });
            });
            const linhaSemColunaBotoes = React.cloneElement(linha, {
                children: linhaModificada,
                botoes: [],
            });

            linhas.push(linhaSemColunaBotoes);
        }

        return linhas;
    }

    function gerarRelatorio({ statusAtivos, cabecalhoSemColunasBotoes, rodape, linhas }) {
        // props.setAguardando(true);
        const filtro = (
            <b style={{ fontSize: "0.8rem" }}>
                Cliente:
                {" " + ((props.listaCliente.find((cliente) => cliente.id == props.filtro.id_cliente) || {}).valor || "Todos") + " - "}
                UC:
                {" " + ((props.listaUnidadeConsumidora.find((uc) => uc.id == props.filtro.id_unidade_consumidora) || {}).valor || "Todas") + " - "}
                Ano:{" " + (props.filtro.ano || "") + " - "}
                Mês:
                {` ${(props.listaMeses.find((mes) => mes.id == props.filtro.mes) || {}).valor || "Todos"} - `}
                Filtro por Status: {String(statusAtivos).replace(/\,/g, ", ")}
            </b>
        );

        const html = ReactDOMServer.renderToString(
            <TabelaFaturaEngenhariaPDF
                dadosImpressao={{
                    filtro,
                    cabecalhoSemColunasBotoes,
                    rodape,
                    linhas,
                }}
            />
        );
        props.gerarRelatorio({ html, landscape: true });
        // props.setArquivoPDF(pdfBase64, "Relatório identificador de multas.pdf", "landscape");
    }
}

const mapStateToProps = (state) => ({
    usuarioLogado: state.auth.usuarioLogado,
    modoTela: state.fatura.modoTela,
    aguardando: state.fatura.aguardando,
    filtro: state.fatura.filtro,
    lista: state.fatura.lista,
    listaCliente: state.fatura.listaCliente,
    listaUnidadeConsumidora: state.fatura.listaUnidadeConsumidora,
    listaMeses: state.fatura.listaMeses,
    pdf: state.displayPDF.pdf,
    nomePdf: state.displayPDF.nomePdf,
    orientation: state.displayPDF.orientation,
});
const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            setModoTela,
            initForm,
            setFiltro,
            salvar,
            salvarMultiplos,
            excluir,
            getListaFaturasEngenharia,
            reprocessar,
            reprocessarTodas,
            buscarPdf,
            setArquivoPDF,
            setAguardando,
            gerarRelatorio,
            getListaClientesUcsFiltradosSelect,
        },
        dispatch
    );
export default connect(mapStateToProps, mapDispatchToProps)(FaturaEngenharia);
